/**
 * Copyright (c) 2019
 * @summary Application Finance Ledger Page
 * @author Nazarii Kuliak
 *
 */
import React from 'react';

import { LedgerTable } from './LedgerTable/LedgerTable';
import { LedgerTopSection } from './LedgerTopSection/LedgerTopSection';
import { LedgerProvider } from './LedgerContext';

import './Ledger.scss';

export default function Ledger() {
  return (
    <LedgerProvider>
      <div className="eds-transaction-ledger">
        <LedgerTopSection />
        <LedgerTable />
      </div>
    </LedgerProvider>
  );
}
